import BaseModel from './BaseModel'
import {
  LOAD_PLAN_ENTRIES_SUCCESS,
  FEATURE_PLAN_ENTRY,
  UNFEATURE_PLAN_ENTRY,
  CLEAR_PLAN_ENTRIES
} from '../redux/actions/planEntries'
import Favorite from './Favorite'
import { fk } from 'redux-orm'
import axiosInstance from 'api/axios.config'

class PlanEntry extends BaseModel {
  static reducer(action, PlanEntry, session) {
    switch (action.type) {
      case CLEAR_PLAN_ENTRIES:
        PlanEntry.filter(action.params).delete()
        break
      case LOAD_PLAN_ENTRIES_SUCCESS:
        action.planEntries.forEach((planEntry) => {
          const entry = session.PlanEntry.upsert({
            ...planEntry,
            favorites: [planEntry.favorite],
            planProduct: planEntry.plan.id
          })

          if (entry.playlistIds) {
            let alreadyIncludedIds = []
            entry.playlistIds.forEach((playlistId) => {
              if (
                !alreadyIncludedIds.includes(playlistId) &&
                !session.PlaylistEntries.filter({
                  playlist: playlistId,
                  planEntry: entry.id,
                  orderBy: entry.playlistOrderby
                }).exists()
              ) {
                session.PlaylistEntries.create({
                  playlist: playlistId,
                  planEntry: entry.id,
                  orderBy: entry.playlistOrderby,
                  createdAt: entry.dateAddedToPlaylist
                })
                alreadyIncludedIds.push(playlistId)
              }
            })
          }
          session.Product.create(planEntry.plan)

          const favorite = planEntry.favorite
          if (favorite) {
            const { id, orderby, createdAt, planEntryId: planEntry } = favorite

            session.Favorite.upsert({
              id,
              orderby,
              createdAt,
              planEntry
            })
          }
        })

        break
      case FEATURE_PLAN_ENTRY:
        PlanEntry.withId(action.id).featured = true
        break
      case UNFEATURE_PLAN_ENTRY:
        PlanEntry.withId(action.id).featured = false
        break
    }
    return undefined
  }

  addToFavorites(params = {}) {
    return Favorite.createNewFavorite(this.id, params)
  }

  entryInPlaylist(playlistUUID) {
    return this.playlistIds.includes(playlistUUID)
  }

  buildEntryUrl(originInfo) {
    let url = `/series/${this.plan.slug}/workouts/${this.id}`

    if (originInfo) {
      url += `?type=${originInfo.type}`

      if (originInfo.type === 'playlist') {
        url += `&uuid=${originInfo.playlistUUID}`
      }
    }

    return url
  }

  feature() {
    return axiosInstance.post(`plan_entries/${this.id}/featured_plan_entries`)
  }

  unfeature() {
    return axiosInstance.delete(`plan_entries/${this.id}/featured_plan_entries`)
  }
}

PlanEntry.modelName = 'PlanEntry'
PlanEntry.apiPath = '/plan_entries'
PlanEntry.fields = {
  planProduct: fk('Product', 'planEntries')
}

export default PlanEntry
